module.exports = __webpack_public_path__ + "img/img5.407f1793.png";